export const REDIRECT_PATH_KEY = "auth_redirect_path";
export const SSO_AUTH_PROGRESS_KEY = "sso_auth_in_progress";
export const REQUIRE_ADDITIONAL_INFO_KEY = "auth_require_additional_info";
export const AUTH_RETURN_PATH_KEY = "returnPath";
